import { render } from "./MeetTheTeam.vue?vue&type=template&id=64b1793e&scoped=true"
import script from "./MeetTheTeam.vue?vue&type=script&lang=js"
export * from "./MeetTheTeam.vue?vue&type=script&lang=js"

import "./MeetTheTeam.vue?vue&type=style&index=0&id=64b1793e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b1793e"]])

export default __exports__